import { formatDate } from 'src/services/utils';

const OrderDates = ({
  creationDate,
  minDeliveryEstimatedDate,
  maxDeliveryEstimatedDate,
}) => (
  <div className="col-12 col-md-6 col-xl-4 d-flex align-items-start gap-3 mt-4">
    <i className="far fa-calendar-alt text-muted mt-1" />{' '}
    <div>
      <p className="text-muted fw-bold mb-1">DATA DO PEDIDO</p>
      <p className="mb-2" data-testid="creationDate">
        {creationDate ? formatDate(creationDate) : ''}
      </p>
      <p className="text-muted fw-bold mb-1">ESTIMATIVA DE ENTREGA</p>
      <p className="mb-0" data-testid="deliveryEstimatedDateRange">
        {minDeliveryEstimatedDate ? (
          <> {formatDate(minDeliveryEstimatedDate)}</>
        ) : (
          ' -'
        )}

        {maxDeliveryEstimatedDate && (
          <>
            {' - '}
            {formatDate(maxDeliveryEstimatedDate)}
          </>
        )}
      </p>
    </div>
  </div>
);

export default OrderDates;
